var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }]
  }, [_c('div', {
    staticClass: "popup_wrap nodeMarkSetting"
  }, [_c('div', {
    staticClass: "popup_title"
  }, [_vm._m(0), _c('a', {
    staticClass: "_command[CmmComm.closeLayer]"
  }, [_c('div', {
    staticClass: "btn_close",
    attrs: {
      "id": "popup_close",
      "title": "Close"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._m(1)])])]), _c('div', {
    staticClass: "popup_content1"
  }, [_c('div', {
    staticClass: "node_Marking_wrap"
  }, [_vm._m(2), _c('ul', {
    staticClass: "node_marking_list"
  }, _vm._l(_vm.nodeArray, function (node, idx) {
    return _c('li', {
      key: idx,
      class: {
        'on': _vm.selectedNodeArray.includes(node.tagKey)
      }
    }, [_c('div', {
      staticClass: "marking_nodetitle_wrap"
    }, [_c('a', {
      staticClass: "marking_nodetitle",
      on: {
        "click": function ($event) {
          return _vm.nodeClick(node.tagKey);
        }
      }
    }, [_vm._v(_vm._s(node.nodeOrder) + ". " + _vm._s(node.text))]), _c('div', {
      staticClass: "marking_fold_area"
    }, [_c('button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: `edit-attr-process-collapse-${idx}`,
        expression: "`edit-attr-process-collapse-${idx}`"
      }],
      staticClass: "node_fold node_fold_down",
      attrs: {
        "title": "펼치기"
      }
    }, [_vm._v(" ")]), _c('button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: `edit-attr-process-collapse-${idx}`,
        expression: "`edit-attr-process-collapse-${idx}`"
      }],
      staticClass: "node_fold node_fold_up",
      attrs: {
        "title": "접기"
      }
    }, [_vm._v(" ")])])]), _c('b-collapse', {
      staticStyle: {
        "cursor": "default"
      },
      attrs: {
        "id": `edit-attr-process-collapse-${idx}`
      }
    }, [_c('div', {
      on: {
        "click": function ($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('ul', {
      staticClass: "nm_inner_list"
    }, [_c('li', {
      staticClass: "on"
    }, [_c('a', {
      staticClass: "nm_title"
    }, [_vm._v("sub 속성1")]), _c('div', {
      staticClass: "tool_wrap"
    }, [_c('a', {
      staticClass: "tool_box tool_up",
      attrs: {
        "title": "순서 올리기"
      }
    }), _c('a', {
      staticClass: "tool_box tool_down",
      attrs: {
        "title": "순서 내리기"
      }
    })])]), _c('li', [_c('a', {
      staticClass: "nm_title"
    }, [_vm._v("sub 속성2")]), _c('div', {
      staticClass: "tool_wrap"
    }, [_c('a', {
      staticClass: "tool_box tool_up",
      attrs: {
        "title": "순서 올리기"
      }
    }), _c('a', {
      staticClass: "tool_box tool_down",
      attrs: {
        "title": "순서 내리기"
      }
    })])])])])])], 1);
  }), 0)])]), _c('div', {
    staticClass: "popup_footer"
  }, [_c('a', {
    staticClass: "btn_type1"
  }, [_vm._v("저장")]), _c('a', {
    staticClass: "btn_type3",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("닫기")])])]), _c('div', {
    staticClass: "mask_wrap",
    staticStyle: {
      "display": "block"
    }
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('span', {
    attrs: {
      "id": "node_title"
    }
  }, [_vm._v("노드표시설정")]), _vm._v(" "), _c('span', {
    staticClass: "node_stitle"
  }, [_vm._v("※ 실험입력 테이블에 표시할 노드는 파란색으로 표시됩니다.")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "btn_close_box"
  }, [_c('span'), _c('span')]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "marking_top"
  }, [_c('div', {
    staticClass: "marking_top_left"
  }, [_c('a', {
    staticClass: "tool_box tool_up",
    attrs: {
      "title": "순서 올리기"
    }
  }), _c('a', {
    staticClass: "tool_box tool_down",
    attrs: {
      "title": "순서 내리기"
    }
  })]), _c('div', {
    staticClass: "marking_top_right"
  }, [_c('button', {
    staticClass: "btn_basic",
    attrs: {
      "title": "편집하기"
    }
  }, [_vm._v("편집하기")]), _c('button', {
    staticClass: "btn_basic",
    attrs: {
      "title": "저장하기"
    }
  }, [_vm._v("저장하기")])])]);

}]

export { render, staticRenderFns }